var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-check-selectbox',{attrs:{"id":"signUpTimezone","width":_vm.width,"height":_vm.height,"full":_vm.full,"maxHeight":321,"search":true,"value":_vm.value,"items":_vm.items,"disabled":_vm.disabled,"readonly":_vm.readonly,"modelError":_vm.modelError,"placeholder":_vm.placeholder},on:{"input":_vm.onCountryCodeChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }